import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { boardEntryPoint } from '@atlassian/jira-spa-apps-board/entrypoint.tsx';

export const boardEmbedPageEntryPoint = createChromelessEntryPoint({
	main: boardEntryPoint,
});
